import { OrderDetails } from "@/types/encomendas";
import { create } from "zustand";

interface OrderPrefetchState {
  orderId: number | null;
  data: OrderDetails | null;
  set: (orderId: number, data: OrderDetails) => void;
  consume: (orderId: number) => OrderDetails | null;
  clear: () => void;
}

const useOrderPrefetchStore = create<OrderPrefetchState>((set, get) => ({
  orderId: null,
  data: null,
  set: (orderId, data) => set({ orderId, data }),
  consume: (orderId) => {
    const state = get();
    if (state.orderId === orderId && state.data) {
      const data = state.data;
      set({ orderId: null, data: null });
      return data;
    }
    return null;
  },
  clear: () => set({ orderId: null, data: null }),
}));

export default useOrderPrefetchStore;
